<template>
  <div>
    <div v-if="loading" class="text-growth-600 p-4 flex items-center gap-2">
      <svg class="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
      Loading...
    </div>
    <div v-else-if="error" class="text-growth-error p-4 bg-red-50 rounded-lg">{{ error }}</div>
    <div v-else class="bg-white rounded-lg border border-growth-50 overflow-hidden">
      <div class="divide-y divide-gray-200 max-h-[calc(100vh-280px)] overflow-y-auto">
        <PracticeListItem
          v-for="practice in practices"
          :key="practice.PAC_ID"
          :practice="practice"
          :selected="selectedPacId === practice.PAC_ID"
          @click="$emit('select', practice)"
        >
          <template #actions>
            <button v-if="practice.TIN_ID" @click.stop="$emit('toggle-aco-builder', practice)" :class="['text-xs px-2 py-1 rounded-full transition-all duration-200', isInRoster(practice.TIN_ID) ? 'bg-growth-tangerine/15 text-growth-tangerine hover:bg-growth-tangerine/25' : 'bg-growth-10 text-growth-600 hover:bg-growth-25']" :title="isInRoster(practice.TIN_ID) ? 'Remove from ACO Builder' : 'Add to ACO Builder'">
              {{ isInRoster(practice.TIN_ID) ? '✓' : '+' }}
            </button>
          </template>
        </PracticeListItem>
        <div v-if="practices.length === 0" class="p-8 text-center text-growth-600 text-sm">No practices found</div>
      </div>
      <div class="border-t border-growth-50 p-2 flex justify-between items-center text-xs text-growth-600">
        <span>{{ pagination.offset + 1 }}-{{ pagination.offset + practices.length }} of {{ formatNumber(pagination.total) }}</span>
        <div class="flex gap-1">
          <button @click="$emit('prev-page')" :disabled="pagination.offset === 0" class="px-3 py-1 border border-growth-50 rounded disabled:opacity-50 hover:bg-growth-10 transition-colors">Prev</button>
          <button @click="$emit('next-page')" :disabled="pagination.offset + pagination.limit >= pagination.total" class="px-3 py-1 border border-growth-50 rounded disabled:opacity-50 hover:bg-growth-10 transition-colors">Next</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PracticeListItem from '../PracticeListItem.vue'

export default {
  name: 'PracticeList',
  components: { PracticeListItem },
  props: {
    practices: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    error: { type: String, default: null },
    pagination: { type: Object, required: true },
    selectedPacId: { type: String, default: null },
    acoBuilderRoster: { type: Array, default: () => [] },
  },
  emits: ['select', 'toggle-aco-builder', 'prev-page', 'next-page'],
  methods: {
    isInRoster(tinId) {
      return this.acoBuilderRoster.some(item => item.tinId === tinId)
    },
    formatNumber(num) {
      if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M'
      if (num >= 1000) return (num / 1000).toFixed(1) + 'K'
      return num?.toLocaleString() || '0'
    },
  },
}
</script>
